import { ContentService } from '@blk/cwp-ng-framework';

import { CellData } from '../cell-data';
import { TableData } from '../table-data';
import { TableDataTransform } from './table-data-transform';

/**
 * Data transform which convert cells - [[0,1], [2,3], [4,5]] ->  [[0,2,4]]  
 * & portfolioData and headersX to [1,3,5]
 */
export class EsgCarbonEmissionTransform implements TableDataTransform {

	public transform(tableData: TableData, contentSvc?: ContentService): TableData {
		const cells: CellData[] = [];
		const headersX: CellData[] = [];
		const benchmarkCells: CellData[] = [];

		tableData?.cells?.forEach(cellData => {
			cells.push(cellData[0]);
			headersX.push(cellData[1]);
			benchmarkCells.push(cellData[2]);
		});

		return new TableData(headersX, tableData.headersY, [cells, benchmarkCells], headersX, tableData.firstColumnTitle);
	}
}
